export default "__VITE_ASSET__D7PlbOO5__"